export default __webpack_public_path__ + "static/media/Gujarat Panchayat Act 1993.48d89bff.pdf";